<template>
  <div id="giosg-header-button" class="mr-[-5px]"></div>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss"></style>
